import { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import DialogActions from '@mui/material/DialogActions';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import LoaderIcon from './LoaderIcon';
import CheckIcon from '@mui/icons-material/Check';
import TextField from '@mui/material/TextField';
import TextAreaWithLimit from './TextAreaWithLimit';
import LoadingButton from '@mui/lab/LoadingButton';

const PushMessageWidgetBody = (props) => {
   const initialState = {
      userIds: '',
      title: '',
      text: '',
   };
   const [formValues, setFormValues] = useState(initialState);

   // validation
   const [formValidation, setFormValidation] = useState({});
   const formIsValid = () => {
      let errors = {};

      if (formValues.userIds.length < 2)
         errors.userIds = 'User IDs must be at least two characters.';
      if (formValues.title.length < 2)
         errors.title = 'Title must be at least two characters.';
      if (formValues.text.length < 2)
         errors.text = 'Text must be at least two characters.';

      setFormValidation(errors);

      return Object.keys(errors).length === 0;
   };

   const handleSendPushMessage = () => {
      if (formIsValid()) {
         props.onSendPushMessage(formValues);
         setFormValues({ ...initialState });
      }
   };

   if (props.loading)
      return (<LoaderIcon />);

   return (
      <Fragment>
         <CardContent>
            <Grid container spacing={1}>
               <Grid item md={12}>
                     <FormControl fullWidth>
                        <TextAreaWithLimit
                           autoFocus
                           id="userids-input"
                           label="User Ids"
                           maxLength={4000}
                           value={formValues.userIds}
                           onChange={event => setFormValues({ ...formValues, userIds: event.target.value })}
                           error={formValidation.userIds ? true : false}
                           helperText={formValidation.userIds}
                           placeholder="Add semi-colon separated user ids..."
                           rows={10}
                        />
                     </FormControl>

                     <FormControl fullWidth>
                        <TextField
                           autoFocus
                           margin="dense"
                           id="title-input"
                           label="Title"
                           type="text"
                           value={formValues.title}
                           onChange={event => setFormValues({ ...formValues, title: event.target.value })}
                           error={formValidation.title ? true : false}
                           helperText={formValidation.title}
                           fullWidth
                        />
                     </FormControl>

                     <FormControl fullWidth>
                        <TextField
                           autoFocus
                           margin="dense"
                           id="text-input"
                           label="Text"
                           type="text"
                           value={formValues.text}
                           onChange={event => setFormValues({ ...formValues, text: event.target.value })}
                           error={formValidation.text ? true : false}
                           helperText={formValidation.text}
                           fullWidth
                        />
                     </FormControl>
                  </Grid>
               </Grid>
         </CardContent>
         <DialogActions>
            <LoadingButton
               loading={props.loading}
               loadingPosition="start"
               startIcon={<CheckIcon />}
               variant="contained"
               onClick={handleSendPushMessage}
            >
               Send
            </LoadingButton>
         </DialogActions>
      </Fragment>
   )
};

PushMessageWidgetBody.propTypes = {
   loading: PropTypes.bool.isRequired,
   onSendPushMessage: PropTypes.func.isRequired,
};

export default PushMessageWidgetBody;
